import Activity, {
  ActivityOptions,
  ActivityType,
  BaseActivityData,
  BaseActivityDataOptions,
  getDefaults as getActivityDefaults,
} from 'models/Activity';

export interface KeyDetailsOptions extends ActivityOptions {
  type: ActivityType.KEY_DETAILS;
  data: Partial<BaseActivityDataOptions>;
}

export function getDefaults(): KeyDetailsOptions {
  return {
    ...getActivityDefaults(),
    type: ActivityType.KEY_DETAILS,
  };
}

export default class KeyDetails extends Activity {
  declare type: ActivityType.KEY_DETAILS;
  declare data: BaseActivityData;

  constructor(options: Partial<KeyDetailsOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);
  }

  get typeLabel() {
    return 'Key Details';
  }
}
